import { ThunkAction } from 'redux-thunk'
import store, { RootState } from '..'
import { authApi } from '../../apis'
import { translate } from '../../languages'
import { UserEntity } from '../../models'
import {
  AuthAction,
  LOGOUT,
  SET_ERROR_LOGIN,
  SET_LOGINING,
  SET_PROFILE,
  SET_PROFILE_LOADED,
} from '../types'

export const login = (
  username: string,
  password: string
): ThunkAction<void, RootState, null, AuthAction> => {
  return async (dispatch) => {
    try {
      dispatch(setErrorLogin(''))
      dispatch(setLogining(true))
      const response = await authApi.login(username, password)
      const { accessToken, refreshToken } = response.data
      localStorage.setItem('accessToken', accessToken)
      localStorage.setItem('refreshToken', refreshToken)
      dispatch(loadProfile())
    } catch (e) {
      const { language } = store.getState().language
      if (e.response && e.response.status === 401) {
        dispatch(setErrorLogin(translate('auth.error.unauthorized', language)))
      } else {
        dispatch(setErrorLogin(translate('auth.error.internal', language)))
      }
      dispatch(setLogining(false))
    }
  }
}

export const setErrorLogin = (msg: string): AuthAction => ({
  type: SET_ERROR_LOGIN,
  payload: msg,
})

export const setLogining = (logining: boolean): AuthAction => ({
  type: SET_LOGINING,
  payload: logining,
})

export const logout = (): ThunkAction<void, RootState, null, AuthAction> => {
  return async (dispatch) => {
    localStorage.removeItem('accessToken')
    dispatch({
      type: LOGOUT,
    })
    await authApi.logout()
    localStorage.removeItem('refreshToken')
  }
}

export const setProfileLoaded = (loaded: boolean): AuthAction => ({
  type: SET_PROFILE_LOADED,
  payload: loaded,
})

export const loadProfile = (): ThunkAction<
  void,
  RootState,
  null,
  AuthAction
> => {
  return async (dispatch) => {
    try {
      dispatch(setLogining(true))
      dispatch(setProfileLoaded(false))
      const userResp = await authApi.profile(
        localStorage.getItem('accessToken') || ''
      )
      const userData = userResp.data
      const user: UserEntity = { ...userData }
      dispatch({
        type: SET_PROFILE,
        payload: user,
      })
    } catch (e) {
      if (
        e.response &&
        e.response.status === 401 &&
        e.response.data &&
        e.response.data.error &&
        e.response.data.error.code === 'token.expired'
      ) {
        const refreshResponse = await authApi.refresh()
        const { accessToken, refreshToken, user } = refreshResponse.data
        localStorage.setItem('accessToken', accessToken)
        localStorage.setItem('refreshToken', refreshToken)
        dispatch({
          type: SET_PROFILE,
          payload: user,
        })
      } else {
        dispatch(logout())
      }
    } finally {
      dispatch(setProfileLoaded(true))
      dispatch(setLogining(false))
    }
  }
}
